import WarningIcon from "../../../assets/images/warning.svg";

const Delete = ({ heading, para, showDelete, setShowDelete, remove }) => {
  return (
    <>
      <div
        className={`${
          showDelete ? "deleteModal visible" : "deleteModal hidden"
        }`}
      >
        <div className="flex">
          <div className="icon">
            <img src={WarningIcon} alt="" />
          </div>
          <div className="content">
            <span className="heading">{heading}</span>
            <span className="para">{para}</span>
          </div>
        </div>
        <div className="action">
          <span
            className="cancel"
            onClick={(e) => {
              setShowDelete(false);
            }}
          >
            Cancel
          </span>
          <span className="delete" onClick={remove}>Delete</span>
        </div>
      </div>
    </>
  );
};

export default Delete;
